<template>
  <div class="modal-column">
    <div class="padding flex-1">
      <p>第一步： 请选择银行科目</p>
      <Select :datas="subjectList" keyName="id" titleName="fullName"
              v-model="subjectId" :deletable="false">
        <template #show="{value}">
          {{ value.code }} {{ value.fullName }}
        </template>
        <template #item="{item}">
          {{ item.code }} {{ item.fullName }}
        </template>
      </Select>
      <p>第一步： 请选择对账单格式</p>
      <Select v-model="fileType" :datas="fileTypeList" :deletable="false"></Select>
      <p>第二步： 请选择对账单文件</p>
      <span class="blue-color text-hover" @click="$refs.file.click()">选取文件</span>
      <div class="h-30px mt-8px"><span v-if="fileName">已选：{{ fileName }}</span></div>
      <input type="file" style="visibility: hidden;position: absolute" @change="fileChange()" ref="file">
    </div>
    <div class="modal-column-btn">
      <Button @click="$emit('close')" :loading="loading">取消</Button>
      <Button color="green" @click="importData" :disabled="!fileName" :loading="loading">银行对账单导入</Button>
    </div>
  </div>
</template>

<script>

import {modal} from "heyui.ext";
import BankStatement from "@api/BankStatement";

export default {
  name: "StatementImport",
  props: {
    account: Object,
    ioType: String,
    subjectList: Array,
    subjectValue: String
  },
  data() {
    return {
      subjectId: null,
      fileTypeList:[
        { title: '农行对账单（.xls）', key: '1'},
        { title: '建行对账单（.txt）', key: '2' },
        { title: '建行对账单（.xls）', key: '3' },
        { title: '建行对账单（.xlsx）', key: '4' },
      ],
      fileType: '1',
      file: null,
      loading: false
    }
  },
  computed: {
    fileName() {
      if (this.file) {
        return this.file.name;
      }
      return '';
    }
  },
  methods: {
    importData() {
      if (this.$refs.file.files.length) {
        let formData = new FormData();

        // 记录类型
        localStorage.setItem('StatementFileType', this.fileType)

        formData.append('file', this.$refs.file.files[0]);
        formData.append('fileType', this.fileType);
        formData.append('subjectId', this.subjectId);
        this.loading = true;
        BankStatement.import(formData).then(({data}) => {
          if (data && data.length) {
            modal({
              title: '如下记录发生错误未导入成功',
              buttons: [{
                type: 'cancel',
                name: '确认',
                style: 'primary'
              }],
              content: data.join("<br>"),
              events: {
                cancel: modal => {
                  this.$refs.file.value = "";
                  this.$emit('success', data);
                  modal.close();
                }
              }
            })
          } else {
            this.$Message("亲,导入成功~");
            this.$refs.file.value = "";
            this.$emit('success', data);
          }
        }).finally(() => {
          this.loading = false;
        }).catch(() => {
          this.$refs.file.value = "";
          this.file = null;
        });
      }
    },
    fileChange() {
      this.file = this.$refs.file.files[0];
    },
  },
  created() {
    this.subjectId = this.subjectValue;
    const statementFileType = localStorage.getItem('StatementFileType')
    if(statementFileType){
      this.fileType = statementFileType;
    }
  }
}
</script>
